import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../_common/platform/ts/ParameterFieldBase';

import { GISPositionField as EditComponent } from '../tsx/GISPositionField';

//declare var require: any;

export class GISPositionField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public getDefaultOptions() {
        return {
            noTitle: true
        };
    }

    constructor(glob, title: string, validators?: any, defaultVal: any = '', options?, directionOptions?) {
        super(glob, title, GISPositionField.defaultValidators, validators, defaultVal, options, directionOptions);
    }
}
